import { render } from "./EmptyText.vue?vue&type=template&id=09528e53&scoped=true"
const script = {}

import "./EmptyText.vue?vue&type=style&index=0&id=09528e53&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09528e53"]])

export default __exports__